import type { AnyContentfulCardDefinition } from '#contentful/ContentfulCard';
import { graphql, useStaticQuery } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { find } from 'lodash/fp';
import { useMemo } from 'react';

export default () => {
  const { language } = useI18next();

  const data = useStaticQuery(graphql`
    query {
      all: allContentfulComponentAutomatedSuggestedContent(
        filter: {contentful_id: {eq: "16hfZHXbpTtF2vT4tykXe0"}}
      ) {
        automatedContent: nodes {
          ...AutomatedSuggestedContent,
          nodeLocale: node_locale
        }
      }
    }
  `);

  const filteredContent = useMemo(() => find(
    ({ nodeLocale }: AnyContentfulCardDefinition) => nodeLocale === language,
    data.all.automatedContent,
  ), [data, language]);

  return filteredContent;
};
